import React, { useEffect } from "react";
import Navbar from "../Navbar";
import {
  Box,
  Button,
  TextField,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
//import { Stack } from '@mui/material';

function EditChallan(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [ChallanInput, setchallan] = useState({
    memo_no: "",
    party_code: "",
    date: "",
    month_of_test: "",
    remarks: "",
    category_id: "",
    category_details_id: "",
    sub_catgory_id: "",
    user_id: "",
    error_list: [],
  });
  const [error, setError] = useState({
    memo_no: "",
    party_code: "",
    date: "",
    month_of_test: "",
    remarks: "",
    category_id: "",
    category_details_id: "",
    sub_catgory_id: "",
    error_list: [],
  });

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });
  const { id } = useParams();
  useEffect(() => {
    const Chalans_id = id;
    axios.get(`/api/edit_chalans/${Chalans_id}`).then((res) => {
      if (res.data.status === 200) {
        setchallan(res.data.Chalans);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/challanform");
      }
      setLoading(false);
    });
  }, [id, navigate]);

  const handleInput = (e) => {
    e.persist();
    setchallan({ ...ChallanInput, [e.target.name]: e.target.value });
  };
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }

  const [sublist, setsublist] = useState([]);
  useEffect(() => {
    axios.get(`api/show_chalans`).then((res) => {
      if (res.status === 200) {
        setsublist(res.data.Chalans);
      }
    });
  }, []);
  const values = sublist.map((item) => {
    return (
      <option color="blue" value={sublist.party_code}>
        {item.party_code}
      </option>
    );
  });
  //   const updateChallanDetails = (e) => {
  //     e.preventDefault();

  //     const data = ChallanInput;
  //     console.log(data);

  //     axios.post(`api/store`,data).then(res =>{
  //         if(res.data.status===200){
  //             swal("Success", res.data.message,"success");
  //             document.getElementById('CATEGORY_FORM').reset();
  //             navigate('/customermaster');
  //         }
  //         else if(res.data.status===400){
  //             setchallan({...ChallanInput, error_list:res.data.errors});
  //         }
  //     });
  // }
  const updateChallanDetails = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");

    // console.log(e.target);
    const Chalans_id = id;
    const data = ChallanInput;
    // console.log(data);
    axios.put(`/api/update_chalans/${Chalans_id}`, data).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        setError([]);
        navigate("/certificates/challanform");
      } else if (res.data.status === 422) {
        // swal("All fields are mandatory","","error");
        setError({ ...ChallanInput, error_list: res.data.errors });
        // setError(res.data.errors);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/challanform");
      }
    });
  };
  return (
    <div>
      <Navbar />
      <div className="card px-8 m-5">
        <div className="card-header">
          <Grid container spacing={70}>
            <Grid item xs={8}>
              <h4>Edit Challan</h4>
            </Grid>
            <Grid item xs={4}>
              <ThemeProvider theme={theme}>
                <Button
                  component={Link}
                  to="/certificates/show_chalans"
                  variant="contained"
                  color="apple"
                >
                  Back
                </Button>
              </ThemeProvider>
            </Grid>
          </Grid>
        </div>
        <form onSubmit={updateChallanDetails} id="CATEGORY_FORM">
          <Box paddingTop={1} borderRadius={1} paddingLeft={5} paddingRight={5}>
            <Grid container spacing={5}>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name=" memo_no"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={ChallanInput.memo_no}
                  id="filled-basic"
                  margin="normal"
                  label="memo_no"
                  variant="filled"
                />
                <span style={{ color: "red" }}>{error.error_list.memo_no}</span>
              </Grid>
              <Grid item xs={4}>
                <select
                  name="party_code"
                  class="form-select"
                  aria-label="Default select example"
                  onChange={handleInput}
                  value={ChallanInput.party_code}
                >
                  <option selected>party_code</option>
                  {values}
                </select>
                {
                  <span style={{ color: "red" }}>
                    {error.error_list.party_code}
                  </span>
                }
              </Grid>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="date"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={ChallanInput.date}
                  id="filled-basic"
                  margin="normal"
                  label="date"
                  variant="filled"
                />
                <span style={{ color: "red" }}>{error.error_list.date}</span>
              </Grid>
            </Grid>

            <Grid container spacing={5}>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="month_of_test"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={ChallanInput.month_of_test}
                  id="filled-basic"
                  margin="normal"
                  label="month_of_test"
                  variant="filled"
                />
                <span style={{ color: "red" }}>
                  {error.error_list.month_of_test}
                </span>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="remarks"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={ChallanInput.remarks}
                  id="filled-basic"
                  margin="normal"
                  label="remarks"
                  variant="filled"
                />
                <span style={{ color: "red" }}>{error.error_list.remarks}</span>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="category_id"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={ChallanInput.category_id}
                  id="filled-basic"
                  margin="normal"
                  label="category_id"
                  variant="filled"
                />
                <span style={{ color: "red" }}>
                  {error.error_list.category_id}
                </span>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                name="sub_catgory_id"
                sx={{ input: { background: "white" } }}
                onChange={handleInput}
                value={ChallanInput.sub_catgory_id}
                id="filled-basic"
                margin="normal"
                label="sub_catgory_id"
                variant="filled"
              />
              <span style={{ color: "red" }}>
                {error.error_list.sub_catgory_id}
              </span>
            </Grid>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              name="category_details_id"
              sx={{ input: { background: "white" } }}
              onChange={handleInput}
              value={ChallanInput.category_details_id}
              id="filled-basic"
              margin="normal"
              label="category_details_id"
              variant="filled"
            />
            <span style={{ color: "red" }}>
              {error.error_list.category_details_id}
            </span>
            <Grid container spacing={5}></Grid>
            <Box
              marginTop={1}
              display="flex"
              padding={3}
              borderRadius={5}
              alignItems="center"
              justifyContent={"center"}
            >
              <ThemeProvider theme={theme}>
                <Button
                  style={{
                    maxWidth: "200px",
                    maxHeight: "100px",
                    minWidth: "50px",
                    minHeight: "30px",
                  }}
                  color="apple"
                  type="submit"
                  component={Link}
                  to="/certificates/show_chalans"
                  variant="contained"
                >
                  Update
                </Button>
              </ThemeProvider>
            </Box>
          </Box>
        </form>
      </div>
    </div>
  );
}

export default EditChallan;
